module.exports = __webpack_public_path__ + "img/giraffe.be5030ca.webp";